import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import {
  STORE_SUBSCRIPTION,
  STORE_ROUTER,
  STORE_AUTH,
  STORE_SUBSCRIPTION_PLAN
} from '../../constants';
import { AsyncLoader } from '../../components/Common/AsyncLoader';
import { PremiumPage as PremiumPageComponent } from '../../components/Premium/PremiumPage';
import { SubscriptionPlan } from '../../models';
import {
  SubscriptionStore,
  RouterStore,
  AuthStore,
  SubscriptionPlanStore,
  SetupCardFunction
} from '../../stores';
import { AsyncStripeProvider } from '../Utils/AsyncStripeProvider';
import './style.css';

export interface PremiumPageProps extends RouteComponentProps<{}> {
  /* empty*/
}

export interface PremiumPageState {
  /* empty*/
}

@inject(STORE_AUTH)
@inject(STORE_ROUTER)
@inject(STORE_SUBSCRIPTION)
@inject(STORE_SUBSCRIPTION_PLAN)
@observer
export class PremiumPage extends React.Component<
  PremiumPageProps,
  PremiumPageState
> {
  private unblockNavigation?: () => void;

  async componentDidMount() {
    const routerStore = this.props[STORE_ROUTER] as RouterStore;
    const subscriptionStore = this.props[
      STORE_SUBSCRIPTION
    ] as SubscriptionStore;

    // Make sure we abandon the subscription flow when the user leaves the page
    this.unblockNavigation = routerStore.history.block(location => {
      // We don't abandon if the user is being redirected to login/register though
      if (!/(login|sign-up)$/.test(location.pathname)) {
        subscriptionStore.abandonSubscriptionFlow();
      }
    });

    return this.loadSubscriptionPlans();
  }

  componentWillUnmount() {
    const { unblockNavigation } = this;

    if (unblockNavigation) {
      unblockNavigation();
    }
  }

  render() {
    const authStore = this.props[STORE_AUTH] as AuthStore;
    const subscriptionStore = this.props[
      STORE_SUBSCRIPTION
    ] as SubscriptionStore;
    const subscriptionPlanStore = this.props[
      STORE_SUBSCRIPTION_PLAN
    ] as SubscriptionPlanStore;
    const { match } = this.props;

    const { subscriptionPlan } = subscriptionPlanStore;

    return (
      <AsyncStripeProvider
        render={stripeReady => {
          return (
            <AsyncLoader
              error={!!subscriptionPlan.error}
              loading={!stripeReady || subscriptionPlan.running}
              pageUrl={match.url}
            >
              <PremiumPageComponent
                error={subscriptionPlan.error}
                isAlreadyAMember={
                  !!authStore.currentUser && authStore.currentUser.isPaidPremium
                }
                isLoggedIn={!!authStore.currentUser}
                isSubscribed={!!subscriptionStore.subscribed.result}
                loading={
                  !stripeReady ||
                  subscriptionPlan.running ||
                  !(subscriptionPlan.result || subscriptionPlan.error)
                }
                monthlyPrice={this.getPriceForPlan(subscriptionPlan.result)}
                onSubscribe={async (setupCard: SetupCardFunction) => {
                  await subscriptionStore.subscribe(
                    (subscriptionPlan.result as SubscriptionPlan).id,
                    setupCard
                  );
                }}
                pageUrl={match.url}
                paymentError={subscriptionStore.subscribed.error}
                paymentRequestRunning={subscriptionStore.subscribed.running}
                redirectAfterSuccessUrl={subscriptionStore.originalUrl}
              />
            </AsyncLoader>
          );
        }}
      />
    );
  }

  private loadSubscriptionPlans = async () => {
    const subscriptionPlanStore = this.props[
      STORE_SUBSCRIPTION_PLAN
    ] as SubscriptionPlanStore;

    return subscriptionPlanStore.fetchSubscriptionPlans();
  };

  private getPriceForPlan = (plan?: SubscriptionPlan): number | undefined => {
    if (!plan) {
      return;
    }

    return plan.amount / 100;
  };
}

export default PremiumPage;



// WEBPACK FOOTER //
// ./src/app/containers/PremiumPage/index.tsx